import { useEffect, useState } from "react";

export default function PDFLoader({ src }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      setIsMobile(
        /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())
      );
    };
    checkMobile();
  }, []);

  return (
    <>
      {isMobile ? (
        <div className="w-full h-auto p-4">
          <div className="flex flex-col items-center justify-center text-center space-y-4">
            <h2 className="text-xl font-semibold text-gray-800">View PDF Document</h2>
            <p className="text-gray-600">Tap the button below to view the PDF on your device.</p>
            <a
              href={src}
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
            >
              Open {src.split("/").pop().replace(".pdf", "").replace(/[-–—]/g, " ")}
            </a>
          </div>
        </div>
      ) : (
        <div className="w-full h-screen p-4">
        <iframe
          src={src}
          title="PDF Viewer"
          className="w-full h-full border rounded-md"
        />
        </div>
      )}
      </>
  );
}
